import { createContext, useContext, useState, lazy, Suspense } from "react";

const DownloadModal = lazy(() =>
  import("@/components/DownloadModal").then((m) => ({ default: m.DownloadModal }))
);

const LeadModalContext = createContext(null);

export const LeadModalProvider = ({ children }) => {
  const [state, setState] = useState({ isOpen: false, source: "hero", plan: null });

  const open = (source = "geral", plan = null) => setState({ isOpen: true, source, plan });
  const close = () => setState((s) => ({ ...s, isOpen: false }));

  return (
    <LeadModalContext.Provider value={{ ...state, open, close }}>
      {children}
      {state.isOpen && (
        <Suspense fallback={null}>
          <DownloadModal />
        </Suspense>
      )}
    </LeadModalContext.Provider>
  );
};

export const useLeadModal = () => useContext(LeadModalContext);
